<template>
  <div id="pers-tab19" name="hres31x-tab19" class="content-pers" :class="{'-fixed-height-box' : pcDisp}">
    <div class="sub-topic-box color-skin" @click="toggleSubTopic1">
      <i class="fa fa-users icon-sub-topic" aria-hidden="true"></i>
      <div class="sub-topic">{{ labels['HRES31XC1']['460'] }}</div>
    </div>

    <div class="data-pers-box" v-show="subTopic1">
      <template v-for="(value, index) in detail.tableEtcData.rows">
        <div class="row data-box">
          <div class="col-xs-6 data-label">{{ value.desother }}</div>
          <div class="col-xs-6 data-text">{{ value.desvalue }}</div>
        </div>
      </template>  
    </div>
    <!--End Topic #1-->
  </div>
</template>

<script>
export default {
  name: 'hres31x-tab19',
  data () {
    return {
      subTopic1: true
    }
  },
  methods: {
    toggleSubTopic1 () {
      this.subTopic1 = !this.subTopic1
    }
  },
  props: [ 'nowLang', 'labels', 'detail', 'pcDisp', 'togglePage', 'triggerButton' ]
}
</script>


// WEBPACK FOOTER //
// tab19.vue?dda485de